// Forecasts
export const FETCH_FORECAST_TRIPS_REQUEST = 'FETCH_FORECAST_TRIPS_REQUEST';
export const FETCH_FORECAST_TRIPS_SUCCESS = 'FETCH_FORECAST_TRIPS_SUCCESS';
export const FETCH_FORECAST_TRIPS_FAILURE = 'FETCH_FORECAST_TRIPS_FAILURE';

export const FETCH_FORECAST_ACTIVITIES_REQUEST = 'FETCH_FORECAST_ACTIVITIES_REQUEST';
export const FETCH_FORECAST_ACTIVITIES_SUCCESS = 'FETCH_FORECAST_ACTIVITIES_SUCCESS';
export const FETCH_FORECAST_ACTIVITIES_FAILURE = 'FETCH_FORECAST_ACTIVITIES_FAILURE';

// Claims
export const FETCH_CLAIMS_TRIPS_REQUEST = 'FETCH_CLAIMS_TRIPS_REQUEST';
export const FETCH_CLAIMS_TRIPS_SUCCESS = 'FETCH_CLAIMS_TRIPS_SUCCESS';
export const FETCH_CLAIMS_TRIPS_FAILURE = 'FETCH_CLAIMS_TRIPS_FAILURE';

export const FETCH_CLAIMS_ACTIVITIES_REQUEST = 'FETCH_CLAIMS_ACTIVITIES_REQUEST';
export const FETCH_CLAIMS_ACTIVITIES_SUCCESS = 'FETCH_CLAIMS_ACTIVITIES_SUCCESS';
export const FETCH_CLAIMS_ACTIVITIES_FAILURE = 'FETCH_CLAIMS_ACTIVITIES_FAILURE';

// Policies
export const FETCH_POLICIES_TRIPS_REQUEST = 'FETCH_POLICIES_TRIPS_REQUEST';
export const FETCH_POLICIES_TRIPS_SUCCESS = 'FETCH_POLICIES_TRIPS_SUCCESS';
export const FETCH_POLICIES_TRIPS_FAILURE = 'FETCH_POLICIES_TRIPS_FAILURE';

export const FETCH_POLICIES_ACTIVITIES_REQUEST = 'FETCH_POLICIES_ACTIVITIES_REQUEST';
export const FETCH_POLICIES_ACTIVITIES_SUCCESS = 'FETCH_POLICIES_ACTIVITIES_SUCCESS';
export const FETCH_POLICIES_ACTIVITIES_FAILURE = 'FETCH_POLICIES_ACTIVITIES_FAILURE';

// Observations
export const FETCH_OBSERVATIONS_ACTIVITIES_REQUEST = 'FETCH_OBSERVATIONS_ACTIVITIES_REQUEST';
export const FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS = 'FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS';
export const FETCH_OBSERVATIONS_ACTIVITIES_FAILURE = 'FETCH_OBSERVATIONS_ACTIVITIES_FAILURE';

// Activity References
export const FETCH_ACTIVITY_REFERENCES_REQUEST = 'FETCH_ACTIVITY_REFERENCES_REQUEST';
export const FETCH_ACTIVITY_REFERENCES_SUCCESS = 'FETCH_ACTIVITY_REFERENCES_SUCCESS';
export const FETCH_ACTIVITY_REFERENCES_FAILURE = 'FETCH_ACTIVITY_REFERENCES_FAILURE';

export const FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST = 'FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST';
export const FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS = 'FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE = 'FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE';

export const CREATE_ACTIVITY_REFERENCE_REQUEST = 'CREATE_ACTIVITY_REFERENCE_REQUEST';
export const CREATE_ACTIVITY_REFERENCE_SUCCESS = 'CREATE_ACTIVITY_REFERENCE_SUCCESS';
export const CREATE_ACTIVITY_REFERENCE_FAILURE = 'CREATE_ACTIVITY_REFERENCE_FAILURE';

export const UPDATE_ACTIVITY_REFERENCE_REQUEST = 'UPDATE_ACTIVITY_REFERENCE_REQUEST';
export const UPDATE_ACTIVITY_REFERENCE_SUCCESS = 'UPDATE_ACTIVITY_REFERENCE_SUCCESS';
export const UPDATE_ACTIVITY_REFERENCE_FAILURE = 'UPDATE_ACTIVITY_REFERENCE_FAILURE';

export const DELETE_ACTIVITY_REFERENCE_REQUEST = 'DELETE_ACTIVITY_REFERENCE_REQUEST';
export const DELETE_ACTIVITY_REFERENCE_SUCCESS = 'DELETE_ACTIVITY_REFERENCE_SUCCESS';
export const DELETE_ACTIVITY_REFERENCE_FAILURE = 'DELETE_ACTIVITY_REFERENCE_FAILURE';

// Activity Subcoverages
export const FETCH_ACTIVITY_SUBCOVERAGES_REQUEST = 'FETCH_ACTIVITY_SUBCOVERAGES_REQUEST';
export const FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS = 'FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS';
export const FETCH_ACTIVITY_SUBCOVERAGES_FAILURE = 'FETCH_ACTIVITY_SUBCOVERAGES_FAILURE';
export const FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST = 'FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST';
export const FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS = 'FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE = 'FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE';

export const CREATE_ACTIVITY_SUBCOVERAGE_REQUEST = 'CREATE_ACTIVITY_SUBCOVERAGE_REQUEST';
export const CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS = 'CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS';
export const CREATE_ACTIVITY_SUBCOVERAGE_FAILURE = 'CREATE_ACTIVITY_SUBCOVERAGE_FAILURE';

export const UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST = 'UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST';
export const UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS = 'UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS';
export const UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE = 'UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE';

export const DELETE_ACTIVITY_SUBCOVERAGE_REQUEST = 'DELETE_ACTIVITY_SUBCOVERAGE_REQUEST';
export const DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS = 'DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS';
export const DELETE_ACTIVITY_SUBCOVERAGE_FAILURE = 'DELETE_ACTIVITY_SUBCOVERAGE_FAILURE';

// Activities
export const FETCH_ACTIVITIES_REQUEST = 'FETCH_ACTIVITIES_REQUEST';
export const FETCH_ACTIVITIES_SUCCESS = 'FETCH_ACTIVITIES_SUCCESS';
export const FETCH_ACTIVITIES_FAILURE = 'FETCH_ACTIVITIES_FAILURE';

export const FETCH_ACTIVITY_BY_ID_REQUEST = 'FETCH_ACTIVITY_BY_ID_REQUEST';
export const FETCH_ACTIVITY_BY_ID_SUCCESS = 'FETCH_ACTIVITY_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_BY_ID_FAILURE = 'FETCH_ACTIVITY_BY_ID_FAILURE';

export const CREATE_ACTIVITY_REQUEST = 'CREATE_ACTIVITY_REQUEST';
export const CREATE_ACTIVITY_SUCCESS = 'CREATE_ACTIVITY_SUCCESS';
export const CREATE_ACTIVITY_FAILURE = 'CREATE_ACTIVITY_FAILURE';

export const UPDATE_ACTIVITY_REQUEST = 'UPDATE_ACTIVITY_REQUEST';
export const UPDATE_ACTIVITY_SUCCESS = 'UPDATE_ACTIVITY_SUCCESS';
export const UPDATE_ACTIVITY_FAILURE = 'UPDATE_ACTIVITY_FAILURE';

export const DELETE_ACTIVITY_REQUEST = 'DELETE_ACTIVITY_REQUEST';
export const DELETE_ACTIVITY_SUCCESS = 'DELETE_ACTIVITY_SUCCESS';
export const DELETE_ACTIVITY_FAILURE = 'DELETE_ACTIVITY_FAILURE';

// Activities Quotes
export const FETCH_ACTIVITIES_QUOTES_REQUEST = 'FETCH_ACTIVITIES_QUOTES_REQUEST';
export const FETCH_ACTIVITIES_QUOTES_SUCCESS = 'FETCH_ACTIVITIES_QUOTES_SUCCESS';
export const FETCH_ACTIVITIES_QUOTES_FAILURE = 'FETCH_ACTIVITIES_QUOTES_FAILURE';

export const FETCH_ACTIVITY_QUOTE_BY_ID_REQUEST = 'FETCH_ACTIVITY_QUOTE_BY_ID_REQUEST';
export const FETCH_ACTIVITY_QUOTE_BY_ID_SUCCESS = 'FETCH_ACTIVITY_QUOTE_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_QUOTE_BY_ID_FAILURE = 'FETCH_ACTIVITY_QUOTE_BY_ID_FAILURE';

export const CREATE_ACTIVITY_QUOTE_REQUEST = 'CREATE_ACTIVITY_QUOTE_REQUEST';
export const CREATE_ACTIVITY_QUOTE_SUCCESS = 'CREATE_ACTIVITY_QUOTE_SUCCESS';
export const CREATE_ACTIVITY_QUOTE_FAILURE = 'CREATE_ACTIVITY_QUOTE_FAILURE';

export const CREATE_POLICY_REQUEST = 'CREATE_POLICY_REQUEST';
export const CREATE_POLICY_SUCCESS = 'CREATE_POLICY_SUCCESS';
export const CREATE_POLICY_FAILURE = 'CREATE_POLICY_FAILURE';

// Action creators
export const fetchForecastTrips = (params = {}) => ({ type: FETCH_FORECAST_TRIPS_REQUEST, payload: params });
export const fetchForecastActivities = () => ({ type: FETCH_FORECAST_ACTIVITIES_REQUEST });
export const fetchClaimsTrips = () => ({ type: FETCH_CLAIMS_TRIPS_REQUEST });
export const fetchClaimsActivities = () => ({ type: FETCH_CLAIMS_ACTIVITIES_REQUEST });
export const fetchPoliciesTrips = (params = {}) => ({ type: FETCH_POLICIES_TRIPS_REQUEST, payload: params });
export const fetchPoliciesActivities = () => ({ type: FETCH_POLICIES_ACTIVITIES_REQUEST });
export const fetchObservationsActivitiesRequest = (params = {}) => ({ type: FETCH_OBSERVATIONS_ACTIVITIES_REQUEST, payload: params });
export const fetchObservationsActivitiesSuccess = (data) => ({ type: FETCH_OBSERVATIONS_ACTIVITIES_SUCCESS, payload: data });
export const fetchObservationsActivitiesFailure = (error) => ({ type: FETCH_OBSERVATIONS_ACTIVITIES_FAILURE, payload: error });

// Activity Observation by ID
export const FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST = 'FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST';
export const FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS = 'FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS';
export const FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE = 'FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE';

export const fetchActivityObservationByIdRequest = (observationId) => ({ type: FETCH_ACTIVITY_OBSERVATION_BY_ID_REQUEST, payload: observationId });
export const fetchActivityObservationByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_OBSERVATION_BY_ID_SUCCESS, payload: data });
export const fetchActivityObservationByIdFailure = (error) => ({ type: FETCH_ACTIVITY_OBSERVATION_BY_ID_FAILURE, payload: error });

// Delete Activity Observation
export const DELETE_ACTIVITY_OBSERVATION_REQUEST = 'DELETE_ACTIVITY_OBSERVATION_REQUEST';
export const DELETE_ACTIVITY_OBSERVATION_SUCCESS = 'DELETE_ACTIVITY_OBSERVATION_SUCCESS';
export const DELETE_ACTIVITY_OBSERVATION_FAILURE = 'DELETE_ACTIVITY_OBSERVATION_FAILURE';

export const deleteActivityObservationRequest = (observationId) => ({ type: DELETE_ACTIVITY_OBSERVATION_REQUEST, payload: observationId });
export const deleteActivityObservationSuccess = (data) => ({ type: DELETE_ACTIVITY_OBSERVATION_SUCCESS, payload: data });
export const deleteActivityObservationFailure = (error) => ({ type: DELETE_ACTIVITY_OBSERVATION_FAILURE, payload: error });
export const fetchActivityReferences = (params = {}) => ({ type: FETCH_ACTIVITY_REFERENCES_REQUEST, payload: params });
export const fetchActivityReferenceByIdRequest = (referenceId) => ({ type: FETCH_ACTIVITY_REFERENCE_BY_ID_REQUEST, payload: referenceId });
export const fetchActivityReferenceByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_REFERENCE_BY_ID_SUCCESS, payload: data });
export const fetchActivityReferenceByIdFailure = (error) => ({ type: FETCH_ACTIVITY_REFERENCE_BY_ID_FAILURE, payload: error });

export const createActivityReferenceRequest = (partnerId, referenceData) => ({ type: CREATE_ACTIVITY_REFERENCE_REQUEST, payload: { partnerId, referenceData } });
export const createActivityReferenceSuccess = (data) => ({ type: CREATE_ACTIVITY_REFERENCE_SUCCESS, payload: data });
export const createActivityReferenceFailure = (error) => ({ type: CREATE_ACTIVITY_REFERENCE_FAILURE, payload: error });

export const updateActivityReferenceRequest = (referenceId, referenceData) => ({ type: UPDATE_ACTIVITY_REFERENCE_REQUEST, payload: { referenceId, referenceData } });
export const updateActivityReferenceSuccess = (data) => ({ type: UPDATE_ACTIVITY_REFERENCE_SUCCESS, payload: data });
export const updateActivityReferenceFailure = (error) => ({ type: UPDATE_ACTIVITY_REFERENCE_FAILURE, payload: error });

export const deleteActivityReferenceRequest = (referenceId) => ({ type: DELETE_ACTIVITY_REFERENCE_REQUEST, payload: referenceId });
export const deleteActivityReferenceSuccess = (data) => ({ type: DELETE_ACTIVITY_REFERENCE_SUCCESS, payload: data });
export const deleteActivityReferenceFailure = (error) => ({ type: DELETE_ACTIVITY_REFERENCE_FAILURE, payload: error });

export const fetchActivitySubcoveragesRequest = (params = {}) => ({ type: FETCH_ACTIVITY_SUBCOVERAGES_REQUEST, payload: params });
export const fetchActivitySubcoveragesSuccess = (data) => ({ type: FETCH_ACTIVITY_SUBCOVERAGES_SUCCESS, payload: data });
export const fetchActivitySubcoveragesFailure = (error) => ({ type: FETCH_ACTIVITY_SUBCOVERAGES_FAILURE, payload: error });
export const fetchActivitySubcoverageByIdRequest = (subcoverageId) => ({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_REQUEST, payload: subcoverageId });
export const fetchActivitySubcoverageByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_SUCCESS, payload: data });
export const fetchActivitySubcoverageByIdFailure = (error) => ({ type: FETCH_ACTIVITY_SUBCOVERAGE_BY_ID_FAILURE, payload: error });
export const createActivitySubcoverageRequest = (referenceId, subcoverageData) => ({ type: CREATE_ACTIVITY_SUBCOVERAGE_REQUEST, payload: { referenceId, subcoverageData } });
export const createActivitySubcoverageSuccess = (data) => ({ type: CREATE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
export const createActivitySubcoverageFailure = (error) => ({ type: CREATE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: error });

export const updateActivitySubcoverageRequest = (subcoverageId, payload) => ({ type: UPDATE_ACTIVITY_SUBCOVERAGE_REQUEST, payload: { subcoverageId, payload } });
export const updateActivitySubcoverageSuccess = (data) => ({ type: UPDATE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
export const updateActivitySubcoverageFailure = (error) => ({ type: UPDATE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: error });

export const deleteActivitySubcoverageRequest = (subcoverageId) => ({ type: DELETE_ACTIVITY_SUBCOVERAGE_REQUEST, payload: subcoverageId });
export const deleteActivitySubcoverageSuccess = (data) => ({ type: DELETE_ACTIVITY_SUBCOVERAGE_SUCCESS, payload: data });
export const deleteActivitySubcoverageFailure = (error) => ({ type: DELETE_ACTIVITY_SUBCOVERAGE_FAILURE, payload: error });

export const fetchActivitiesRequest = (params = {}) => ({ type: FETCH_ACTIVITIES_REQUEST, payload: params });
export const fetchActivitiesSuccess = (data) => ({ type: FETCH_ACTIVITIES_SUCCESS, payload: data });
export const fetchActivitiesFailure = (error) => ({ type: FETCH_ACTIVITIES_FAILURE, payload: error });

export const fetchActivityByIdRequest = (activityId) => ({ type: FETCH_ACTIVITY_BY_ID_REQUEST, payload: activityId });
export const fetchActivityByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_BY_ID_SUCCESS, payload: data });
export const fetchActivityByIdFailure = (error) => ({ type: FETCH_ACTIVITY_BY_ID_FAILURE, payload: error });

export const createActivityRequest = (partnerId, activityData) => ({ type: CREATE_ACTIVITY_REQUEST, payload: { partnerId, activityData } });
export const createActivitySuccess = (data) => ({ type: CREATE_ACTIVITY_SUCCESS, payload: data });
export const createActivityFailure = (error) => ({ type: CREATE_ACTIVITY_FAILURE, payload: error });

export const updateActivityRequest = (activityId, activityData) => ({ type: UPDATE_ACTIVITY_REQUEST, payload: { activityId, activityData } });
export const updateActivitySuccess = (data) => ({ type: UPDATE_ACTIVITY_SUCCESS, payload: data });
export const updateActivityFailure = (error) => ({ type: UPDATE_ACTIVITY_FAILURE, payload: error });

export const deleteActivityRequest = (activityId) => ({ type: DELETE_ACTIVITY_REQUEST, payload: activityId });
export const deleteActivitySuccess = (data) => ({ type: DELETE_ACTIVITY_SUCCESS, payload: data });
export const deleteActivityFailure = (error) => ({ type: DELETE_ACTIVITY_FAILURE, payload: error });

export const fetchActivitiesQuotesRequest = (params = {}) => ({ type: FETCH_ACTIVITIES_QUOTES_REQUEST, payload: params });
export const fetchActivitiesQuotesSuccess = (data) => ({ type: FETCH_ACTIVITIES_QUOTES_SUCCESS, payload: data });
export const fetchActivitiesQuotesFailure = (error) => ({ type: FETCH_ACTIVITIES_QUOTES_FAILURE, payload: error });

export const fetchActivityQuoteByIdRequest = (quoteId) => ({ type: FETCH_ACTIVITY_QUOTE_BY_ID_REQUEST, payload: quoteId });
export const fetchActivityQuoteByIdSuccess = (data) => ({ type: FETCH_ACTIVITY_QUOTE_BY_ID_SUCCESS, payload: data });
export const fetchActivityQuoteByIdFailure = (error) => ({ type: FETCH_ACTIVITY_QUOTE_BY_ID_FAILURE, payload: error });

export const createActivityQuoteRequest = (activityId) => ({ type: CREATE_ACTIVITY_QUOTE_REQUEST, payload: activityId });
export const createActivityQuoteSuccess = (data) => ({ type: CREATE_ACTIVITY_QUOTE_SUCCESS, payload: data });
export const createActivityQuoteFailure = (error) => ({ type: CREATE_ACTIVITY_QUOTE_FAILURE, payload: error });

export const createPolicyRequest = (quoteId, clientId, policyData) => ({ type: CREATE_POLICY_REQUEST, payload: { quoteId, clientId, policyData } });

// Bulk Transfers
export const GENERATE_BULK_TRANSFERS_CSV_REQUEST = 'GENERATE_BULK_TRANSFERS_CSV_REQUEST';
export const GENERATE_BULK_TRANSFERS_CSV_SUCCESS = 'GENERATE_BULK_TRANSFERS_CSV_SUCCESS';
export const GENERATE_BULK_TRANSFERS_CSV_FAILURE = 'GENERATE_BULK_TRANSFERS_CSV_FAILURE';

export const GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_REQUEST = 'GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_REQUEST';
export const GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_SUCCESS = 'GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_SUCCESS';
export const GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_FAILURE = 'GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_FAILURE';

export const generateBulkTransfersCsvRequest = (params = {}) => ({ type: GENERATE_BULK_TRANSFERS_CSV_REQUEST, payload: params });
export const generateBulkTransfersCsvSuccess = (data) => ({ type: GENERATE_BULK_TRANSFERS_CSV_SUCCESS, payload: data });
export const generateBulkTransfersCsvFailure = (error) => ({ type: GENERATE_BULK_TRANSFERS_CSV_FAILURE, payload: error });

export const generateBulkTransfersCsvByPolicyCodesRequest = (params = {}) => ({ type: GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_REQUEST, payload: params });
export const generateBulkTransfersCsvByPolicyCodesSuccess = (data) => ({ type: GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_SUCCESS, payload: data });
export const generateBulkTransfersCsvByPolicyCodesFailure = (error) => ({ type: GENERATE_BULK_TRANSFERS_CSV_BY_POLICY_CODES_FAILURE, payload: error });

// Bulk Transfers End of Stay
export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_REQUEST = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_REQUEST';
export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_SUCCESS = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_SUCCESS';
export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_FAILURE = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_FAILURE';

export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_REQUEST = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_REQUEST';
export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_SUCCESS = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_SUCCESS';
export const GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_FAILURE = 'GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_FAILURE';

export const generateBulkTransfersCsvEndOfStayRequest = (params = {}) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_REQUEST, payload: params });
export const generateBulkTransfersCsvEndOfStaySuccess = (data) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_SUCCESS, payload: data });
export const generateBulkTransfersCsvEndOfStayFailure = (error) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_FAILURE, payload: error });

export const generateBulkTransfersCsvEndOfStayByPolicyCodesRequest = (params = {}) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_REQUEST, payload: params });
export const generateBulkTransfersCsvEndOfStayByPolicyCodesSuccess = (data) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_SUCCESS, payload: data });
export const generateBulkTransfersCsvEndOfStayByPolicyCodesFailure = (error) => ({ type: GENERATE_BULK_TRANSFERS_CSV_END_OF_STAY_BY_POLICY_CODES_FAILURE, payload: error });
export const createPolicySuccess = (data) => ({ type: CREATE_POLICY_SUCCESS, payload: data });
export const createPolicyFailure = (error) => ({ type: CREATE_POLICY_FAILURE, payload: error });



